/**************************************************
 * Nombre:       Formulario_Pdfs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {TitleOutlined} from "@mui/icons-material";
import IngresoPdf from "../../../Modulo_formularios/Componentes/IngresoPdf";
import IngresoImagen from "../../../Modulo_formularios/Componentes/IngresoImagen";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Pdfs = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imange del Pdf Opcional</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop  dato={'img'} {...props} ancho={3} alto={4}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoPdf dato={'pdf'} {...props} ancho={2} alto={3}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del Pdf'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pdfs